const corporateClinic = {
  // HeroSection
  'corporateClinic.hero.homeLink': 'ホーム',
  'corporateClinic.hero.corporateLink': '法人研修',
  'corporateClinic.hero.currentPage': '医療・美容クリニック向け',
  'corporateClinic.hero.title': '医療・美容クリニック向け 法人研修',
  'corporateClinic.hero.titleEn': 'FOR CLINICS & PRIVATE MEDICAL',
  'corporateClinic.hero.lead': 'クリニック向け研修は、自由診療にふさわしい接遇と気遣いを、執事の基準で院内に定着させるプログラムです。',
  'corporateClinic.hero.cta': 'この業種で相談する',
  'corporateClinic.hero.imgAlt': '受付カウンターで患者様に笑顔で寄り添うクリニックスタッフ',
  'corporateClinic.hero.badge1': '不安に寄り添う所作を「手順」として体系化',
  'corporateClinic.hero.badge2': '診療後の夜間・休診日の出張実施に対応',
  'corporateClinic.hero.badge3': '執事養成課程と同一の講師陣',

  // PainPoints
  'corporateClinic.pain.label': 'CHALLENGES',
  'corporateClinic.pain.title': 'こんな課題をお持ちではありませんか',
  'corporateClinic.pain.titleEn': 'Common Challenges',
  'corporateClinic.pain.lead': '自由診療では、接遇そのものが医院選びの決め手になります。患者様が院内に入った瞬間から「ここなら安心して任せられる」と感じていただける接遇品質が求められています。',
  'corporateClinic.pain.0': '高単価の自由診療では、接遇そのものが医院選びの理由になっています。技術の高さに加え、「ここなら安心して任せられる」という印象を、患者様が院内に入った瞬間から感じられるかが問われています。',
  'corporateClinic.pain.1': '受付・カウンセラーの言葉遣いや所作にばらつきがあります。スタッフの経験年数や性格に依存した接遇では、医院全体としての統一感が損なわれ、患者様の信頼感にも影響を及ぼします。',
  'corporateClinic.pain.2': '不安や緊張を抱えた患者様への距離感が個人任せになっています。「過度に踏み込みすぎず、それでいて冷たくない」距離の取り方を、感覚ではなく共通の型として院内に定着させたいという声を多くいただきます。',
  'corporateClinic.pain.3': '費用や施術内容など、デリケートな話題の伝え方を統一したい。治療の説明やお断りの場面では、一言の言い回しで患者様の安心感が大きく変わります。全スタッフが同じ水準で対応できる体制が必要です。',

  // WhyButlerWorks
  'corporateClinic.why.label': 'WHY BUTLER METHOD',
  'corporateClinic.why.title': 'なぜ執事の作法がクリニックに効くのか？',
  'corporateClinic.why.titleEn': 'Why the Butler Approach Works',
  'corporateClinic.why.lead1': '不安を抱えた患者様への寄り添いと、執事が主の体調を察して動く技術は、本質的に同じです。気持ち任せにせず、所作と手順で揃えます。',
  'corporateClinic.why.lead2': '本研修が提供するのは、日本の執事学校でプロの執事が培った接遇の型を、クリニックの現場で使える接遇品質として定着させることです。',
  'corporateClinic.why.0.title': '相手の体調や気分の機微を察して動く執事の技術が、患者様への寄り添いと重なる',
  'corporateClinic.why.0.desc': '執事は、主の体調や気分のわずかな変化を察知し、求められる前に先回りして動く職業です。この「察する技術」は、不安や緊張を抱えてご来院される患者様への寄り添いとそのまま重なります。気持ち任せにせず、所作と手順で揃えます。',
  'corporateClinic.why.1.title': '守秘とプライバシー配慮を「気持ち」ではなく「所作と手順」として教えられる',
  'corporateClinic.why.1.desc': '「患者様のプライバシーを大切に」という掛け声だけでは、現場での実践にばらつきが出ます。執事教育では、声のトーン、書類の差し出し方、案内の動線に至るまで、守秘を「見える所作」に落とし込んで訓練します。',
  'corporateClinic.why.2.title': 'ご案内・お茶出し・お見送りの型を整えることで、誰が対応しても同じ品質を保てる',
  'corporateClinic.why.2.desc': 'ベテランだからできる接遇ではなく、新人・パートスタッフでも再現できる「型」として接遇を設計します。ご案内の先導、お茶の出し方、お見送りの引き際——一つひとつの所作を標準化することで、院内の誰が対応しても患者様に同じ安心感をお届けできます。',

  // RecommendedPrograms
  'corporateClinic.rec.label': 'RECOMMENDED',
  'corporateClinic.rec.title': '推奨プログラム構成',
  'corporateClinic.rec.titleEn': 'Program Examples for Clinics',
  'corporateClinic.rec.lead': '診療科目や課題に合わせて最適な研修構成をご提案します。診療後の夜間開催・休診日開催にも対応します。',
  'corporateClinic.rec.badge': '標準',
  'corporateClinic.rec.priceSuffix': '円（税込）',
  'corporateClinic.rec.corporateLink': '法人研修総合ページ',
  'corporateClinic.rec.corporateLinkText': 'モジュールの詳細は',
  'corporateClinic.rec.corporateLinkSuffix': 'をご覧ください。',
  'corporateClinic.rec.0.duration': '3時間',
  'corporateClinic.rec.0.modules': 'M1（立ち居振る舞い）＋ M2（距離感・守秘・言葉遣いの原則）',
  'corporateClinic.rec.0.description': '立ち居振る舞いの基本と、医療現場に不可欠な距離感・守秘の原則を集中的に学ぶ短期プランです。導入研修として、まずは全スタッフの土台を揃える目的に最適です。',
  'corporateClinic.rec.1.duration': '6時間',
  'corporateClinic.rec.1.modules': 'M1 ＋ M2 ＋ M3（ご案内・お茶出し実技）＋ M4（デリケートな場面のロールプレイング）',
  'corporateClinic.rec.1.description': '所作からデリケートな場面の実技対応まで、クリニック接遇の基盤を1日で網羅する推奨プランです。診療後の夜間開催・休診日開催にも対応します。',
  'corporateClinic.rec.2.duration': '月1回半日（3時間）×6ヶ月',
  'corporateClinic.rec.2.modules': '全6モジュールを6回で段階的に習得',
  'corporateClinic.rec.2.description': '新人の受け入れや接遇基準の定着に推奨のプランです。月1回のペースで段階的に全モジュールを習得し、定期的な振り返りにより接遇品質の継続的な維持・向上を図ります。',

  // ScenarioTraining
  'corporateClinic.scenario.label': 'SCENARIOS',
  'corporateClinic.scenario.title': 'クリニック特化の演習シナリオ',
  'corporateClinic.scenario.titleEn': 'Clinic Training Scenarios',
  'corporateClinic.scenario.lead': '研修は実際の院内動線を再現して行います。代表的なシナリオを三つご紹介します。',
  'corporateClinic.scenario.note': '※シナリオは診療科目・院内環境に合わせて調整できます。',
  'corporateClinic.scenario.0.title': '受付からご案内まで',
  'corporateClinic.scenario.0.desc': 'ご来院時の第一声、動線の先導、待合室でのお声がけからカウンセリング室へのご案内までを、プライバシーに配慮した所作で通し演習します。受付での視線の合わせ方、カルテや同意書を差し出す角度と距離、他の患者様の目に触れない動線の選び方——すべてを実技で確認します。',
  'corporateClinic.scenario.1.title': 'カウンセリング室での接遇',
  'corporateClinic.scenario.1.desc': 'お茶出しのタイミングと所作、資料の差し出し方、費用のご説明時の言葉選びと間の取り方をロールプレイングします。患者様の目線に合わせた着席位置、説明資料を広げる角度、金額を告げる際の自然な間——接遇の細部が患者様の安心感を左右します。',
  'corporateClinic.scenario.2.title': 'デリケートな場面での対応',
  'corporateClinic.scenario.2.desc': '施術への不安をお持ちの患者様への応対、予算のご相談を受けた際の言い回し、お断りせざるを得ないご要望への対応を、安心感を損なわない言い回しで練習します。「安全第一」の姿勢を崩さず、それでいて患者様の尊厳を守る伝え方を、実技で繰り返し訓練します。',

  // TargetRoles
  'corporateClinic.target.label': 'TARGET',
  'corporateClinic.target.title': '対象職種・推奨人数',
  'corporateClinic.target.titleEn': 'Target Roles & Capacity',
  'corporateClinic.target.lead': '受付から院長まで、患者様と接するすべての職種の皆様にご受講いただけます。小規模院は2〜3名でも実施可能です。',
  'corporateClinic.target.capacity': '推奨12名まで',
  'corporateClinic.target.capacityNote': '小規模院は2〜3名でも実施可能です。その分、お一人あたりの実技時間を厚く設計します。診療後の夜間・休診日開催に対応します。',
  'corporateClinic.target.role0': '受付・コンシェルジュ',
  'corporateClinic.target.role1': 'カウンセラー',
  'corporateClinic.target.role2': '看護師・歯科衛生士（接遇場面）',
  'corporateClinic.target.role3': '事務長・院長',
  'corporateClinic.target.role4': '電話応対担当',

  // PricingTable
  'corporateClinic.pricing.label': 'PRICING',
  'corporateClinic.pricing.title': '料金プラン',
  'corporateClinic.pricing.titleEn': 'Transparent Pricing',
  'corporateClinic.pricing.lead': 'すべて税込価格での明確な料金体系です。貴院のご予算と目標に合わせて最適なプランをお選びいただけます。',
  'corporateClinic.pricing.colPlan': 'プラン',
  'corporateClinic.pricing.colDuration': '時間',
  'corporateClinic.pricing.colPrice': '料金（税込）',
  'corporateClinic.pricing.colNote': '内容',
  'corporateClinic.pricing.badge': '標準',
  'corporateClinic.pricing.priceSuffix': '円',
  'corporateClinic.pricing.conditionsTitle': '共通条件',
  'corporateClinic.pricing.corporateLinkText': '継続プログラム・覆面サービス診断などの全メニューは',
  'corporateClinic.pricing.corporateLink': '法人研修総合ページ',
  'corporateClinic.pricing.corporateLinkSuffix': 'をご覧ください。',
  'corporateClinic.pricing.cta': '研修について問い合わせる',
  'corporateClinic.pricing.plan0.name': '半日プラン',
  'corporateClinic.pricing.plan0.duration': '3時間',
  'corporateClinic.pricing.plan0.note': '2モジュール選択',
  'corporateClinic.pricing.plan1.name': '1日プラン',
  'corporateClinic.pricing.plan1.duration': '6時間',
  'corporateClinic.pricing.plan1.note': '4モジュール選択',
  'corporateClinic.pricing.plan2.name': '2日間パッケージ',
  'corporateClinic.pricing.plan2.duration': '2日間（各6時間）',
  'corporateClinic.pricing.plan2.note': '全モジュール対応',
  'corporateClinic.pricing.plan3.name': '継続プログラム',
  'corporateClinic.pricing.plan3.duration': '月1回半日×6ヶ月',
  'corporateClinic.pricing.plan3.note': '全6モジュールを段階的に習得',
  'corporateClinic.pricing.cond.dispatch': '出張時の交通費は実費別途',
  'corporateClinic.pricing.cond.capacity': '推奨12名まで。小規模院は2〜3名でも実施可能です（その分、お一人あたりの実技時間を厚く設計します）。',
  'corporateClinic.pricing.cond.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporateClinic.pricing.cond.night': '診療後の夜間開催・休診日開催に対応します。',
  'corporateClinic.pricing.cond.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',

  // FlowSteps
  'corporateClinic.flow.label': 'FLOW',
  'corporateClinic.flow.title': 'ご利用の流れ',
  'corporateClinic.flow.titleEn': 'From Inquiry to Results',
  'corporateClinic.flow.lead': 'お問い合わせから実施後レポートまで、5つのステップで進めます。診療に影響しない日程でご提案します。',
  'corporateClinic.flow.step0.title': 'お問い合わせ',
  'corporateClinic.flow.step0.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporateClinic.flow.step1.title': 'ヒアリング',
  'corporateClinic.flow.step1.desc': '診療科目・課題・対象人数・ご希望時期などをオンラインまたはお電話で伺います。事前に研修内容資料をお送りすることも可能です。',
  'corporateClinic.flow.step2.title': 'プログラム提案・お見積り',
  'corporateClinic.flow.step2.desc': 'ヒアリング内容をもとに、貴院に最適な研修プログラムとお見積りをご提案します。概算お見積りのみのご依頼でも構いません。稟議のご準備にもご活用いただけます。',
  'corporateClinic.flow.step3.title': '実施',
  'corporateClinic.flow.step3.desc': '出張または来校にて研修を実施します。出張型では貴院の待合室・カウンセリング室を使用し、実際の動線で訓練することで研修翌日からの再現性が高まります。診療後の夜間や休診日など、診療に影響しない日程でご提案します。',
  'corporateClinic.flow.step4.title': '実施後レポート',
  'corporateClinic.flow.step4.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',

  // ContactForm
  'corporateClinic.contact.label': 'CONTACT',
  'corporateClinic.contact.title': 'お問い合わせ',
  'corporateClinic.contact.titleEn': 'Inquiry Form',
  'corporateClinic.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporateClinic.contact.phoneText': 'フォームのほか、お電話',
  'corporateClinic.contact.phoneOr': 'またはメール',
  'corporateClinic.contact.phoneAccept': 'でも承ります。',
  'corporateClinic.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporateClinic.contact.company': '会社名・医院名',
  'corporateClinic.contact.department': '部署・役職',
  'corporateClinic.contact.name': 'ご担当者名',
  'corporateClinic.contact.nameRequired': '必須',
  'corporateClinic.contact.namePlaceholder': '例: 執事 太郎',
  'corporateClinic.contact.nameError': 'ご担当者名は必須です',
  'corporateClinic.contact.email': 'メールアドレス',
  'corporateClinic.contact.emailRequired': '必須',
  'corporateClinic.contact.emailPlaceholder': '例: taro@example.com',
  'corporateClinic.contact.emailError': 'メールアドレスは必須です',
  'corporateClinic.contact.emailInvalidError': '有効なメールアドレスを入力してください',
  'corporateClinic.contact.phone': '電話番号',
  'corporateClinic.contact.phoneRequired': '必須',
  'corporateClinic.contact.phonePlaceholder': '例: 090-1234-5678',
  'corporateClinic.contact.phoneError': '電話番号は必須です',
  'corporateClinic.contact.medicalField': '診療科目・業態',
  'corporateClinic.contact.medicalFieldRequired': '必須',
  'corporateClinic.contact.medicalFieldError': '診療科目をお選びください',
  'corporateClinic.contact.format': '希望形式',
  'corporateClinic.contact.participants': '想定人数',
  'corporateClinic.contact.participantsPlaceholder': '例: 5名',
  'corporateClinic.contact.timeline': '検討時期',
  'corporateClinic.contact.timelinePlaceholder': '例: 来月、今期中、未定',
  'corporateClinic.contact.message': 'ご相談内容（任意）',
  'corporateClinic.contact.messagePlaceholder': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporateClinic.contact.messageMax': '500文字以内で入力してください',
  'corporateClinic.contact.submitError': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporateClinic.contact.submitting': '送信中...',
  'corporateClinic.contact.submit': 'この内容で送信する',
  'corporateClinic.contact.companyPlaceholder': '例: ○○クリニック',
  'corporateClinic.contact.departmentPlaceholder': '例: 院長',
  'corporateClinic.contact.medOpt0': '選択してください',
  'corporateClinic.contact.medOpt1': '美容',
  'corporateClinic.contact.medOpt2': '審美歯科',
  'corporateClinic.contact.medOpt3': '人間ドック',
  'corporateClinic.contact.medOpt4': 'その他自由診療',
  'corporateClinic.contact.medOpt5': 'その他',
  'corporateClinic.contact.fmtOpt0': '選択してください',
  'corporateClinic.contact.fmtOpt1': '出張',
  'corporateClinic.contact.fmtOpt2': '来校',
  'corporateClinic.contact.fmtOpt3': '未定',

  // FAQSection
  'corporateClinic.faq.label': 'FAQ',
  'corporateClinic.faq.title': 'よくあるご質問',
  'corporateClinic.faq.titleEn': 'Frequently Asked Questions',
  'corporateClinic.faq.note': 'その他のご質問はフォームよりお寄せください',
  'corporateClinic.faq.0.q': '執事の資格が取れる研修ですか？',
  'corporateClinic.faq.0.a': 'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  'corporateClinic.faq.1.q': '診療後の夜間や休診日に実施できますか？',
  'corporateClinic.faq.1.a': 'はい、対応します。開始時刻と会場条件をヒアリング時にお知らせください。診療に影響しない日程でご提案いたしますので、ご希望の時間帯をお気軽にご相談ください。',
  'corporateClinic.faq.2.q': '一般的な医療接遇マナー研修と何が違いますか？',
  'corporateClinic.faq.2.a': '患者様おひとりに「仕える」設計である点です。動作のマナーにとどまらず、距離感・守秘・デリケートな話題の伝え方までを実技で扱います。一般的な医療接遇研修が「してはいけないこと」の確認に終始しがちなのに対し、本研修は「すべきこと」を型として身につける実技訓練です。',
  'corporateClinic.faq.3.q': '受付2名だけの小規模でも依頼できますか？',
  'corporateClinic.faq.3.a': 'はい、可能です。料金はプラン単位のため少人数でも同額ですが、その分お一人ずつの実技時間を厚く設計します。講師が1対1に近い密度で指導しますので、むしろ少人数のほうが細部まで行き届いた訓練が可能です。',

  // CTASection
  'corporateClinic.cta.label': 'GET STARTED',
  'corporateClinic.cta.title': 'まずはお気軽にご相談ください',
  'corporateClinic.cta.lead': '診療後の夜間・休診日の実施にも対応します。診療科目と課題をお聞かせください。',
  'corporateClinic.cta.sub': '貴院の診療内容や患者様層をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporateClinic.cta.inquiry': '研修について問い合わせる',
  'corporateClinic.cta.courses': '個人向けコースを見る',

  // RelatedPages
  'corporateClinic.related.label': 'OTHER INDUSTRIES',
  'corporateClinic.related.title': '他の業種向けプログラム',
  'corporateClinic.related.titleEn': 'Training for Other Industries',
  'corporateClinic.related.viewLink': '詳しく見る',
  'corporateClinic.related.corporateBack': '法人研修総合ページへ戻る',
  'corporateClinic.related.coursesLink': '個人向けコース（執事養成課程）を見る',
  'corporateClinic.related.0.title': 'ホテル・旅館',
  'corporateClinic.related.0.desc': 'バトラーサービスの型を開業前に整える',
  'corporateClinic.related.1.title': '高級レジデンス',
  'corporateClinic.related.1.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'corporateClinic.related.2.title': '金融・プライベートバンク',
  'corporateClinic.related.2.desc': '富裕層営業の所作と距離感を鍛える',
  'corporateClinic.related.3.title': '百貨店外商・高級小売',
  'corporateClinic.related.3.desc': 'お得意様対応と訪問の作法を底上げ',
  'corporateClinic.related.4.title': 'ラグジュアリー営業',
  'corporateClinic.related.4.desc': '高級車・宝飾・不動産の商談体験を設計',
  'corporateClinic.related.5.title': '自動車・モビリティ',
  'corporateClinic.related.5.desc': 'ブランド体験の接遇を高める',
  'corporateClinic.related.6.title': 'ハイヤー・送迎',
  'corporateClinic.related.6.desc': '乗降の所作と車内の気配りを磨く',

  // page.tsx
  'corporateClinic.page.lastUpdated': '最終更新: 2026年6月13日',
};

export default corporateClinic;
